import CheckmarkIcon from "./components/CheckmarkIcon";
import ErrorIcon from "./components/ErrorIcon";
import WarningIcon from "./components/WarningIcon";

type iconTypes = "GOOD" | "BAD" | "WARN";
type OnboardingIndicatorProps = {
  calendarAccessable: boolean,
  EpicScheduleSlotsAccessable: boolean,
  EpicRoundsAccessable: boolean,
  EpicAppointmentsAccessable: boolean,
}

export default function OnboardingIndicators(props: OnboardingIndicatorProps){
  function createButton(text: string, appearsToBeFunctioning: boolean ){
    let iconType: iconTypes = appearsToBeFunctioning ? "GOOD" : "WARN"

    if (iconType === "GOOD") {
      return <div className="tw-border-green-600 tw-text-black tw-bg-green-400/[.2] tw-max-w-xs tw-p-4 tw-rounded-md tw-border tw-flex tw-flex-row tw-items-center tw-space-x-2">
        <span className="tw-text-green-800 tw-h-5 tw-w-5"><CheckmarkIcon /></span>
        <div className="tw-text-green-900">{text}</div>
      </div>
    } else if (iconType === "WARN") {
      return <div className="tw-border-yellow-600 tw-text-black tw-bg-yellow-400/[.2] tw-max-w-xs tw-p-4 tw-rounded-md tw-border tw-flex tw-flex-row tw-items-center tw-space-x-2">
        <span className="tw-text-yellow-800 tw-h-5 tw-w-5"><WarningIcon /></span>
        <div className="tw-text-yellow-900">{text}</div>
      </div>
    }

    return <div className="tw-border-red-600 tw-text-black tw-bg-red-400/[.2] tw-max-w-xs tw-p-4 tw-rounded-md tw-border tw-flex tw-flex-row tw-items-center tw-space-x-2">
      <span className="tw-text-red-800 tw-h-5 tw-w-5"><ErrorIcon /></span>
      <div className="tw-text-red-900">{text}</div>
    </div>
  }

  return(
    <div>
      <div className="tw-space-y-3">
        {createButton("Outlook", props.calendarAccessable)}
        {createButton("Template", props.EpicScheduleSlotsAccessable)}
        {createButton("Rounds", props.EpicRoundsAccessable)}
        {createButton("Appointments", props.EpicAppointmentsAccessable)}
      </div>
    </div>
  )
}